import gql from "graphql-tag";

export const createOde = gql`
  mutation CreateOde($data: ODECreateInput!) {
    createODE(data: $data){
      id
    }
  }
`;